<template>
    <div class="wrapper-bg">
        <LoadingSSO :isShow="loading" />
        <div class="main-layout coffee">
            <div class="text-center">
                <img
                    class="wrapper_title_logo"
                    src="@/assets/home/logo-new-theme.png"
                />
            </div>
            <div class="active-main">
                <div class="active-greeting">
                    <div>ยินดีต้อนรับ !</div>
                    <div>กลับสู่ Nescafé Street Café</div>
                </div>
                <div class="white-line"></div>
                <div class="active-desc">
                    ขอให้สนุกกับการร่วมกิจกรรมและแลกรับของรางวัล
                </div>
                <div class="brown-btn" @click="$bvModal.show('modalConfirm')">
                    เปิดใช้งานบัญชีของคุณ
                </div>
            </div>
        </div>
        <b-modal
            id="modalConfirm"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="order-main">
                <div class="order-header">
                    <div class="title-scc">
                        <h2>เปิดใช้งานบัญชี</h2>
                    </div>
                </div>
                <div @click="showMobile()" class="brown-btn">ยืนยัน</div>
                <div
                    class="underline-btn"
                    @click="$bvModal.hide('modalConfirm')"
                >
                    ไม่เปิดใช้งาน
                </div>
            </div>
        </b-modal>
        <b-modal
            id="modalMobile"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="order-main">
                <div class="close-btn" @click="$bvModal.hide('modalMobile')">
                    <img src="@/assets/profile/close-new.svg" alt="" />
                </div>
                <div class="order-header">
                    <div class="title-scc">
                        <h2 class="title-otp">กรอกเบอร์โทรศัพท์</h2>
                        <div class="otp-desc">
                            กรุณากรอกเบอร์โทรศัพท์เพื่อรับรหัส OTP
                            สำหรับยืนยันตัวตน
                        </div>
                    </div>
                </div>
                <div
                    :class="errorPhone ? 'mobile-input-error' : 'mobile-input'"
                >
                    <InputContactNumber
                        inputId="contact-number"
                        delimeter="-"
                        :inputLbl="lbl.profile.contactnumber"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[0]"
                        :showLabel="false"
                        :dashColor="false"
                        :errorPhone="errorPhone"
                        :inputMaxLength="12"
                        @input="inputChange"
                        v-model="contactNo"
                    ></InputContactNumber>
                    <div v-if="errorPhone" class="error-message">
                        {{ errorPhone }}
                    </div>
                </div>
                <div v-if="contactNo.length < 10" class="gray-btn">ยืนยัน</div>
                <div v-else @click="onclickOtp()" class="brown-btn">ยืนยัน</div>
            </div>
        </b-modal>
        <b-modal
            id="modalVerifyOtp"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="order-main">
                <div class="close-btn" @click="closeOtp()">
                    <img src="@/assets/profile/close-new.svg" alt="" />
                </div>
                <div class="order-header">
                    <div class="title-scc">
                        <h2 class="title-otp">กรอกรหัสยืนยันตัวตน OTP</h2>
                        <div class="otp-desc">
                            ระบบได้ทำการส่งรหัส OTP สำหรับยืนยันตัวตนให้คุณทาง
                            SMS ของเบอร์
                        </div>
                        <div class="phone-desc">{{ formatPhoneNumber }}</div>
                        <div class="ref-desc">รหัสอ้างอิง {{ refcode }}</div>
                    </div>
                </div>
                <div class="text-center">
                    <label
                        for="input-otp"
                        :class="{ 'input-otp': !isErrorMessage }"
                    >
                        <div class="d-flex justify-content-center">
                            <div
                                class="box-input-otp"
                                :class="{
                                    error: !isExpireTime || isErrorMessage,
                                }"
                            >
                                {{ otp[0] }}
                            </div>
                            <div
                                class="box-input-otp"
                                :class="{
                                    error: !isExpireTime || isErrorMessage,
                                }"
                            >
                                {{ otp[1] }}
                            </div>
                            <div
                                class="box-input-otp"
                                :class="{
                                    error: !isExpireTime || isErrorMessage,
                                }"
                            >
                                {{ otp[2] }}
                            </div>
                            <div
                                class="box-input-otp"
                                :class="{
                                    error: !isExpireTime || isErrorMessage,
                                }"
                            >
                                {{ otp[3] }}
                            </div>
                            <div
                                class="box-input-otp"
                                :class="{
                                    error: !isExpireTime || isErrorMessage,
                                }"
                            >
                                {{ otp[4] }}
                            </div>
                            <div
                                class="box-input-otp"
                                :class="{
                                    error: !isExpireTime || isErrorMessage,
                                }"
                            >
                                {{ otp[5] }}
                            </div>
                        </div>
                    </label>
                </div>
                <input
                    type="tel"
                    id="input-otp"
                    class="input-otp-dummy"
                    maxlength="6"
                    v-model="otp"
                    @input="onOtpChange()"
                />
                <div class="err-otp" v-if="isErrorMessage">
                    {{ errorMessage }}
                </div>
                <div class="timer" v-if="isExpireTime">
                    ส่งรหัส OTP อีกครั้ง ในเวลา
                    <span>{{ timeHelper.displayTime }}</span>
                </div>
                <div
                    class="resend"
                    v-if="!isExpireTime"
                    :class="{ expired: !isExpireTime }"
                    @click="resendOtp()"
                >
                    ส่งรหัส OTP อีกครั้ง
                </div>
                <div
                    v-if="otp.length < 6"
                    class="gray-btn"
                    @click="onSubmitOtp()"
                >
                    ยืนยันรหัส
                </div>
                <div v-else class="brown-btn" @click="onSubmitOtp()">
                    ยืนยันรหัส
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
//service
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
//component
import InputContactNumber from "@/components/Input/EditContactNumber.vue";
import LoadingSSO from "@/components/LoadingSSO/Loading.vue";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
import TimerHelper from "@/helper/TimerHelper.js";
import FormHelper from "@/helper/FormHelper.js";
//locale
import Locale from "@/helper/locale/locale.js";

import Mixin from "@/mixin/Mixin";

export default {
    name: "activeuser",
    data() {
        return {
            timeHelper: new TimerHelper(),
            lbl: Locale.getLbl(),
            otp: "",
            tel: "",
            refcode: "",
            isFirstSave: true,
            errorInfo: [],
            contactNo: "",
            errorPhone: "",
            isErrorMessage: false,
            isExpireTime: false,
            formatPhoneNumber: "",

            mixins: [Mixin],

            cacheHelper: new CacheHelper(),
            tokenbzbs: "",

            loading: false,
        };
    },
    components: {
        InputContactNumber,
        LoadingSSO,
    },
    created() {
        this.errorInfo = FormHelper.genErrorInfo(1);
        this.tokenbzbs = this.cacheHelper.getCache("linetoken");
    },
    methods: {
        onclickOtp: async function () {
            await this.apiRequestOtp();
        },
        apiRequestOtp: async function () {
            this.loading = true;
            return new Promise(() => {
                BzbsAuth.apiVerifyResume(
                    this.tokenbzbs,
                    this.contactNo
                ).subscribe(
                    (data) => {
                        console.log(data);
                        this.errorPhone = "";
                        this.refcode = data.refcode;
                        this.setFormat();
                        //set timeout to 5 minutes
                        this.timeHelper.initialTimer(
                            60 * 5,
                            null,
                            false,
                            false
                        );
                        this.startOtp();
                        this.$bvModal.hide("modalMobile");
                        this.$bvModal.show("modalVerifyOtp");
                        this.loading = false;
                    },
                    (err) => {
                        console.log(err);
                        if (
                            err.error.data.success === false &&
                            err.error.data.result === "unmatched"
                        ) {
                            this.errorPhone =
                                "เบอร์โทรศัพท์ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง";
                        } else {
                            this.errorPhone =
                                "ท่านเข้าสู่ระบบนานกรุณาเข้าสู่ระบบใหม่อีกครั้ง";
                        }
                        this.loading = false;
                    }
                );
            });
        },
        inputChange() {
            this.errorPhone = "";
        },
        startOtp: async function () {
            this.isExpireTime = false;
            if (this.resend === false) {
                this.tel = this.contactNo;
            } else {
                this.timeHelper.stopTimer();
                this.timeHelper.resetTimer();
            }

            this.otp = "";

            this.isErrorMessage = false;

            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });
            this.isExpireTime = true;
        },
        cancelOtp: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();

            this.$store.commit("setDupphone", {
                isdup: false,
                message: "",
            });
        },
        closeOtp() {
            this.cancelOtp();
            this.$bvModal.hide("modalVerifyOtp");
        },
        onOtpChange: function () {
            this.isErrorMessage = false;
            this.otp = this.otp.replace(/\D/g, "");
        },
        setTimeout: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = false;
        },
        onSubmitOtp: async function () {
            if (this.validateOtp()) {
                await this.apiValidateOtp();
            }
            this.$bvModal.hide("modalVerifyOtp");
        },
        apiValidateOtp: async function () {
            this.loading = true;
            return new Promise((resolve, reject) => {
                BzbsAuth.apiResume(
                    this.tokenbzbs,
                    this.contactNo,
                    this.otp,
                    this.refcode
                ).subscribe(
                    (data) => {
                        console.log(data);
                        this.$router.push("/linelogin");
                        this.loading = false;
                        resolve(true);
                    },
                    (err) => {
                        this.isErrorMessage = true;
                        this.errorMessage = err.message;
                        if (err.message === "รหัส OTP ไม่ถูกต้อง") {
                            this.errorMessage =
                                "รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง";
                        }
                        this.loading = false;
                        reject(false);
                    }
                );
            });
        },
        validateOtp: function () {
            if (this.otp.length != 6) {
                this.errorMessage = this.lbl.otp.otpLength;
                if (this.otp == "") {
                    this.errorMessage = this.lbl.otp.requireInput;
                }
                this.isErrorMessage = true;
                return false;
            }

            return true;
        },
        setFormat() {
            var n1, n2, n3;
            n1 = this.contactNo.substr(0, 3);
            n2 = this.contactNo.substr(3, 3);
            n3 = this.contactNo.substr(6);
            this.formatPhoneNumber = n1 + "-" + n2 + "-" + n3;
        },
        resendOtp: async function () {
            this.isExpireTime = false;
            this.isErrorMessage = false;

            await this.clickResend();
            this.resend = true;
            await this.startOtp();
        },
        clickResend: async function () {
            return new Promise((resolve, reject) => {
                BzbsAuth.apiVerifyResume(
                    this.tokenbzbs,
                    this.contactNo
                ).subscribe(
                    (data) => {
                        this.refcode = data.refcode;
                        resolve(true);
                    },
                    (err) => {
                        console.log(err);
                        reject(false);
                    }
                );
            });
        },
        showMobile() {
            this.$bvModal.show("modalMobile");
            this.$bvModal.hide("modalConfirm");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
@import "@/style/_mixin.scss";
.coffee:after {
    display: none;
}
.wrapper-bg {
    padding-bottom: 0px !important;
}
.underline-btn {
    color: $color-text !important;
}
.active-main {
    margin: 100px 20px 0;

    .active-greeting {
        color: $color-text;
        font-family: "PromptBold";
        text-align: center;
    }
    .active-desc {
        color: $color-text-light;
        text-align: center;
        padding: 0 60px 40px;
    }
}

::v-deep.order-main {
    .order-header {
        .title-scc {
            .title-otp {
                color: $color-text !important;
            }
        }
        .otp-desc {
            text-align: center;
            font-family: "PromptSemiBold";
            color: $color-text-light;
            margin-bottom: 15px;
        }
        .phone-desc {
            text-align: center;
            color: $dark-brown;
            font-size: 18px;
        }
        .ref-desc {
            text-align: center;
            color: $color-brown-600;
            margin-bottom: 15px;
        }
    }
    .err-otp {
        color: $red-color;
        text-align: center;
    }
    .resend {
        text-decoration: underline;
        color: $light-brown;
        margin: 40px 0;
        text-align: center;
    }
    .timer {
        margin: 40px 0;
        color: $color-text;
        text-align: center;
        span {
            font-family: "PromptSemiBold";
            color: $red-color;
        }
    }
    .mobile-input {
        margin: 40px 0;
        .text-wrapper {
            text-align: center;
            .input-box {
                color: #4c341c;
                .input-field {
                    text-align: center;
                }
            }
            .placeholder {
                color: #c2c2c2;
            }
        }
        .error-message {
            font-size: 14px;
            margin: 10px 0 auto;
            width: 90%;
        }
    }
    .mobile-input-error {
        margin: 40px 0;
        .text-wrapper {
            text-align: center;
            .input-box {
                color: #e1261c;
                .input-field {
                    text-align: center;
                }
            }
            .placeholder {
                color: #c2c2c2;
            }
        }
        .error-message {
            font-size: 14px;
            margin: 10px 0 auto;
            width: 90%;
        }
    }
}
</style>
